import InputNoRowSelectWithLabelAndValidation from './InputNoRowSelectWithLabelAndValidation'

export default InputNoRowSelectWithLabelAndValidation
